require('./faq.less');
require('../impromptu/impromptu');
import Trackers from '../tracker/tracker';

let form = require('../form/form');

jQuery(function() {
    $(document).on('click', '.js-add-question-shop', function(e) {
        e.preventDefault();
        $.ajax({
            url: '/ajax/action/shop_questions/showAddForm/',
            success: function(result) {
                let trackers = new Trackers();
                trackers.onPMbtnFAQ();

                addQuestionPrompt.addQuestion.html = result.html;
                $.prompt(addQuestionPrompt);
            }
        });
    });

    var addQuestionPrompt = {
        addQuestion: {
            submit: function(e, v, m) {
                e.preventDefault();
                var $params = $.extend({}, form.formValidateDefaults, {
                    rules: {
                        question_name: { required: true },
                        question_email: { required: true, email: true },
                        question_phone: { required: true, phoneMask: true },
                        question_city: { required: true },
                        question_activity: { required: true }
                    },
                    messages: {
                        question_name: { required: 'Не указано имя' },
                        question_city: { required: 'Не указан город' },
                        question_activity: {
                            required: 'Не указан род деятельности'
                        },
                        question_email: {
                            required: $.validator.messages.EMAIL.required,
                            email: $.validator.messages.EMAIL.email
                        },
                        question_phone: {
                            required: $.validator.messages.PHONE.required,
                            phoneMask: $.validator.messages.PHONE.phoneMask
                        }
                    },
                    submitHandler: function() {
                        $.ajax({
                            type: 'POST',
                            url: '/ajax/action/shop_questions/add/',
                            data: $('form.jqiform').serializeArray(),
                            success: function(result) {
                                $.prompt
                                    .getState('addQuestion')
                                    .find('.form')
                                    .html('<p>' + result.html + '</p>');

                                let trackers = new Trackers();
                                trackers.onPMfrmFAQ();

                            }
                        });
                        //т.к. изменилась высота блока, надо его подвинуть в видимую часть окна,
                        // чтобы не казалось, будто он совсем пропал с экрана
                        $.prompt.position();
                    }
                });
                var $form = m.closest('form');
                $form.validate($params);
            }
        }
    };
});



// WEBPACK FOOTER //
// ./blocks/faq/faq.js